import Autoload from "../../Autoload";

class TemplateServices {
    
    postTemplates=(functionCallingContext, responseFunctionName=null, callBackData=null, payload)=>{
        if(payload?.body || payload?.subject){
          console.log('payload: ', payload);
          
          Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl + 'messageTemplates',
            'POST',
            payload,
            null,
            false,
            true,
            false,
            functionCallingContext,
            responseFunctionName,
            callBackData,
            false,
            '',
            {
              Authorization: Autoload.Utils.getAuthToken(),
            }
          );
        }
    }

    putTemplates=(functionCallingContext, responseFunctionName=null, callBackData=null, payload)=>{
        if(payload?.body || payload?.subject){
          Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl + 'messageTemplates/'+ payload?.id,
            'PUT',
            payload,
            null,
            false,
            true,
            false,
            functionCallingContext,
            responseFunctionName,
            callBackData,
            false,
            '',
            {
              Authorization: Autoload.Utils.getAuthToken(),
            }
          );
        }
    }

    getTemplates=(functionCallingContext, responseFunctionName, callBackData=null, props, url_part ="templates?accountId=" )=>{
      console.log('props: ', props);
      
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl+'messageTemplates/GetAllByAccount?offset=0&fetch=10',//+url_part+props?.propertySelected?.accountId,//+"&propertyId="+(props.propertyId ? props.propertyId : "")+"&templateType="+(props.templateType ? props.templateType : "")+"&offset=0&fetch=100",
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            callBackData, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    getSystemTemplates=(functionCallingContext, responseFunctionName, callBackData=null, props, url_part ="templates?accountId=" )=>{
      console.log('props: ', props);
      
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl+'messageTemplates',
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            callBackData, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }
    
    getTemplateById=(functionCallingContext, responseFunctionName, callBackData=null, id)=>{
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl+"messageTemplates/"+id,
            "GET", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            callBackData, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }

    deleteTemplate=(functionCallingContext, responseFunctionName=null, callBackData=null, id)=>{
        Autoload.HttpRequestAxios.HttpRequest(
            Autoload.Setting.user_reg_api_baseurl+"messageTemplates/"+id,
            "DELETE", 
            null, null, false, true, false,
            functionCallingContext,
            responseFunctionName, 
            callBackData, false, "",
            { 
                'Content-Type': 'application/json',
                'Authorization': Autoload.Utils.getAuthToken()
            }
        );
    }
}

export default new TemplateServices();

